module.exports = __webpack_public_path__ + "img/pv-chat-green.9ab1676b.svg";